module.exports = __webpack_public_path__ + "static/staff-title-d7899b9148fd0947cc79e027901f8ca7.svg";